"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.message = exports.heading = exports.success = void 0;

var _react = require("@emotion/react");

var _polished = require("polished");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  text-align: center;\n  mix-blend-mode: normal;\n  opacity: 0.8;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 18px 0 8px;\n  mix-blend-mode: normal;\n  opacity: 0.8;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  height: 198px;\n  width: 204px;\n  padding: 28px 23px 21px;\n  background: ", ";\n  backdrop-filter: blur(45.91px);\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var success = function success(_ref) {
  var colors = _ref.colors;
  return (0, _react.css)(_templateObject(), (0, _polished.rgba)(colors.white, 0.4), colors.primary);
};

exports.success = success;
var heading = (0, _react.css)(_templateObject2());
exports.heading = heading;
var message = (0, _react.css)(_templateObject3());
exports.message = message;